module.exports = __webpack_public_path__ + "static/img/LOGO（仮）.82539e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO（仮）.png
// module id = brum
// module chunks = 0